/*
 * Custom "Buy it now" — adds the product straight to the order and goes to
 * the standard checkout (no Shop Pay wallet button, no cart page in between).
 *
 * Renders on every product page from buy-buttons.liquid, so it works with or
 * without a cross-sell block. When a cross-sell add-on is present and ticked,
 * it rides along as its own line with the _added_from property — the same
 * outcome as "Add to cart", just sent to /checkout.
 */
(function () {
  if (window.__buyItNowInit) return;
  window.__buyItNowInit = true;

  document.addEventListener(
    'click',
    function (evt) {
      var btn = evt.target.closest && evt.target.closest('[data-cross-sell-buy-now]');
      if (!btn || btn.hasAttribute('disabled') || btn.getAttribute('aria-busy') === 'true') return;

      evt.preventDefault();

      var form = btn.closest('form');
      if (!form) return;
      var formId = form.getAttribute('id');

      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value || idInput.disabled) return; // no variant / sold out

      var qtyInput =
        form.querySelector('[name="quantity"]') ||
        document.querySelector('[name="quantity"][form="' + formId + '"]');
      var qty = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) || 1 : 1;

      var items = [{ id: idInput.value, quantity: qty }];

      // Any ticked cross-sell add-on for this form (skip if already in the cart)
      document
        .querySelectorAll('product-cross-sell[data-product-form-id="' + formId + '"]')
        .forEach(function (el) {
          var cb = el.querySelector('[data-cross-sell-checkbox]');
          if (cb && cb.checked && el.dataset.variantId && !el.addonInCart) {
            items.push({
              id: el.dataset.variantId,
              quantity: 1,
              properties: { _added_from: 'product-page' },
            });
          }
        });

      // Loading state on the button
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('loading');
      var spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var addUrl = (window.routes && routes.cart_add_url) || '/cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
        });
    },
    false
  );
})();
